import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProfileComponent } from './pages/profile/profile.component';
import { PractitionerScheduleComponent } from './pages/schedule/schedule.component';
import { PractionerRoutingModule } from './practitioner-routing.module';
import { HomePractitionerComponent } from './pages/home/home-practitioner.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ScheduleSelectComponent } from './pages/schedule/select/schedule-select.component';
import { PractitionerPatientDetailsComponent } from './pages/patient/details/patient-details.component';
import { PractitionerPatientComponent } from './pages/patient/patient.component';
import { PractitionerOrganizationComponent } from './pages/organization/organization.component';
import { PractitionerOrganizationDetailsComponent } from './pages/organization/details/organization-details.component';
import { PractitionerOrganizationLinkComponent } from './pages/organization/bond/organization-link.component';
import { PractitionerCalendarComponent } from './pages/calendar/calendar.component';
import { CalendarDayViewComponent, CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CalendarComponent } from './pages/schedule/calendar/calendar.component';
import { PractitionerSchedulerComponent } from './pages/scheduler/scheduler.component';
import { PractitionerRegistrationComponent } from './components/practitioner-registration/practitioner-registration.component';
import { PractitionerMapComponent } from './components/map/map.component';
import { PractitionerQualificationFormComponent } from './components/qualification-form/qualification-form.component';
import { SelectProcedureComponent } from './pages/organization/bond/select-procedure/select-procedure.component';
import { PractitionerScheduleDetailsComponent } from './pages/schedule/status/details/schedule-details.component';
import { ScheduleEditStatusComponent as PractitionerScheduleEditStatusComponent } from './pages/schedule/status/edit-status/schedule-edit-status.component';
import { PractitionerScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PractitionerScheduleAppointmentComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { PractitionerScheduleProcedureComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { PractitionerScheduleRegistrationComponent } from './pages/schedule/registration/schedule-registration.component';
import { PaymentDetailsComponent } from './pages/payment/payment-details/payment-details.component';
import { PractitionerPractitionerroleFormComponent } from './components/practitionerrole/practitionerrole-form.component';
import { RegisterHoursComponent } from './components/register-hours/register-hours';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { PractitionerOrganizationBondDetailsComponent } from './pages/organization/bond/bond-details/organization-bond-details.component';
import { HealthPlanComponent } from './components/health-plan/health-plan.component';
import { PatientPreviousEncounterDetails } from './components/patient-previous-encounters-details/patient-previous-encounters-details';
import { CreatePrescription } from './components/create-prescription/create-prescription';
import { RequestHoursChanges } from './components/request-hours-changes/request-hours-changes';
import { PractitionerDashboardComponent } from './pages/dashboard/dashboard.component';
import { CalendarDayOptionsComponent } from './components/calendar-day-options/calendar-day-options.component';
import { MatRadioModule } from '@angular/material/radio';
import { PractitionerRevenueComponent } from './pages/revenue/revenue.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    HomePractitionerComponent,
    ProfileComponent,
    ScheduleSelectComponent,
    PaymentComponent,
    PractitionerScheduleComponent,
    PractitionerPatientComponent,
    PractitionerPatientDetailsComponent,
    PractitionerOrganizationLinkComponent,
    PractitionerOrganizationComponent,
    PractitionerOrganizationDetailsComponent,
    PractitionerCalendarComponent,
    CalendarComponent,
    PractitionerSchedulerComponent,
    PractitionerRegistrationComponent,
    PractitionerMapComponent,
    PractitionerQualificationFormComponent,
    SelectProcedureComponent,
    PractitionerScheduleDetailsComponent,
    PractitionerScheduleEditStatusComponent,
    PractitionerScheduleStatusComponent,
    PractitionerScheduleAppointmentComponent,
    PractitionerScheduleProcedureComponent,
    PractitionerScheduleRegistrationComponent,
    PaymentDetailsComponent,
    PractitionerPractitionerroleFormComponent,
    RegisterHoursComponent,
    PractitionerOrganizationBondDetailsComponent,
    HealthPlanComponent,
    PatientPreviousEncounterDetails,
    CreatePrescription,
    RequestHoursChanges,
    PractitionerDashboardComponent,
    CalendarDayOptionsComponent,
    PractitionerRevenueComponent,
  ],
  exports: [
    PractitionerPatientComponent,
    PractitionerPatientDetailsComponent,
    PractitionerOrganizationLinkComponent,
    PractitionerOrganizationComponent,
    PractitionerOrganizationDetailsComponent,
    PractitionerCalendarComponent,
    PractitionerRegistrationComponent,
    PractitionerMapComponent,
    PractitionerQualificationFormComponent,
    SelectProcedureComponent,
    PractitionerScheduleDetailsComponent,
    PractitionerScheduleStatusComponent,
    PractitionerScheduleAppointmentComponent,
    PractitionerScheduleProcedureComponent,
    PractitionerScheduleRegistrationComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    PractionerRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatIconModule,
    MatChipsModule,
    MatSelectModule,
    MatTabsModule,
    MatCardModule,
    MatToolbarModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSliderModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatDatepickerModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatAutocompleteModule,
  ],
})
export class PractitionerModule {}
